
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CartPage from "./views/CartPage";
import LandingPage from "./views/LandingPage";
import OrderPage from "./views/OrderPage";
import PurchaseSuccessPage from "./views/Purchase/PurchaseSuccessPage";
import PurchaseFailedPage from "./views/Purchase/PurchaseFailedPage";
import PurchaseCanceledPage from "./views/Purchase/PurchaseCanceledPage";
import AdminPage from "./views/AdminPage";
import FunnelPage from "./views/FunnelPage";
import ErrorBoundary from "./components/ErrorBoundary";
import config from "./config";
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    document.title = `${config.branding.appName} - Checkout`;
  }, []);

  return (
    <ErrorBoundary>
      <Router basename={config.path_prefix}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/track" element={<OrderPage />} />
          <Route path="/purchase/success" element={<PurchaseSuccessPage />} />
          <Route path="/purchase/failed" element={<PurchaseFailedPage />} />
          <Route path="/purchase/canceled" element={<PurchaseCanceledPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/funnel" element={<FunnelPage />} />
          <Route path="/funnel/:slug" element={<FunnelPage />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
